module.exports = __webpack_public_path__ + "img/flutter-dark.d8548a85.png";